import axiosClient from './axiosClient';

export async function fetchContextualHelpItems() {
  const { data } = await axiosClient.get('/contextual-help');
  return data.items ?? [];
}

export async function openContextualHelpChat(locale) {
  const { data } = await axiosClient.post('/chat/contextual-help/open', { locale });
  return { conversationId: data.conversationId, title: data.title };
}
